import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { compose, graphql } from 'react-apollo'
import { Form, Row, Col, Tag, Button } from 'antd'
import moment from 'moment'
import _get from 'lodash/get'
import _sortBy from 'lodash/sortBy'
import { FormattedMessage } from 'react-intl'
import RegistrationSteps from '../../../components/RegistrationSteps'
import registrationQuery from '~/App/graphql/queries/registration.gql'
import getAgeCategory from '~/App/utils/getAgeCategory'

// const getAgeCategory = ({
//   race: { startTime, ageCategories, ageCategoryDiff },
//   birthDate,
//   gender
// }) => {
//   // TODO: important use race
//   const $birthDate = moment(birthDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
//   const {
//     month, date, hour, minute, second, millisecond
//   } = $birthDate.toObject()
//   let $startTime = moment(startTime).set({
//     month, date, hour, minute, second, millisecond
//   })
//   if (ageCategoryDiff === 'day') {
//     $startTime = moment(startTime).set({
//       hour, minute, second, millisecond
//     })
//   }
//   const fullAge = $startTime.diff($birthDate, 'year') // moment(startTime).year() - moment(birthDate).year()
//   return {
//     category: ageCategories.filter(cat => cat.gender === gender).find(cat => {
//       return (
//         (!cat.min && cat.max >= fullAge) ||
//         (!cat.max && cat.min <= fullAge) ||
//         (cat.min <= fullAge && cat.max >= fullAge)
//       )
//     }),
//     gender
//   }
// }
const taxInvoiceOptions = [{
  _id: 'none',
  en: 'None',
  th: 'ไม่ขอใบกำกับภาษี'
}, {
  _id: 'individual',
  en: 'Individual',
  th: 'บุคคล'
}, {
  _id: 'company',
  en: 'Company',
  th: 'บริษัท'
}]

// const ageCategoryString = ({ category, gender }) => {
//   const g = gender ? gender[0].toUpperCase() : ''
//   if (!category) {
//     return 'open'
//   }
//   const { min, max } = category
//   if (!min && max) {
//     return `${g} under ${max + 1}`
//   } else if (min && !max) {
//     return `${g} ${min} up`
//   } else {
//     return `${g} ${min} - ${max}`
//   }
// }

const bibNumber = number => {
  const pad = '0000'
  return pad.substr(0, pad.length - `${number}`.length) + number
}

class RegistrationView extends Component {
  state = {
    id: '',
    submitting: false
  }

  ageCategoryString = ({ category, gender }) => {
    const g = gender ? gender[0].toUpperCase() : ''
    if (!category) {
      return <FormattedMessage id="app.ageCategories.open" />
    }
    const { min, max } = category
    if (!min && max) {
      return <FormattedMessage id="app.ageCategories.under" values={{ gender: g, upper: max + 1}} />
      // return `${g} under ${max + 1}`
    } else if (min && !max) {
      return <FormattedMessage id="app.ageCategories.over" values={{ gender: g, lower: min }} />
      // return `${g} ${min} up`
    } else {
      return <FormattedMessage id="app.ageCategories.between" values={{ gender: g, lower: min, upper: max }} />
      // return `${g} ${min} - ${max}`
    }
  }

  handleSubmit = ({ registrationId }) => {
    this.props.submitRegistration({
      variables: { _id: registrationId }
    })
    // .then(console.log) // redirect to pay
  }

  render () {
    // console.log('render')
    const { data, i18n: { locale } } = this.props
    const eventProducts = _get(data, 'registration.eventProducts', [])
    const { registration } = data
    // const { search } = this.props.location
    // const { l: locale = 'en' } = queryString.parse(search)
    // console.log(locale)
    if (!registration) {
      return <div>Loading...</div>
    }
    const {
      // _id,
      expireAt,
      expired,
      event,
      participants,
      amount,
      status,
      code,
      registrationType,
      couponCodes
    } = registration
    const hideNumber = _get(event, 'settings.ticket.hideNumber')
    const systemFee = _get(event, 'settings.registration.fee', 0)
    // console.log({ hideNumber }, event.settings)
    // successfulPayment
    const { slug } = event
    // const currentPeriod = periods.find(period =>
    //   moment().isBetween(period.start, period.end)
    // )

    const $paymentStatus = ({
      paid: <Tag color="green">{_get(amount, 'discounted')} THB ({
        <FormattedMessage id="paymentStatus.paid" defaultMessag="Paid" />
      })</Tag>,
      payment_verifying: (
        <Tag color="yellow">{_get(amount, 'discounted')} THB ({
          <FormattedMessage id="paymentStatus.verifying" defaultMessag="Pending Verification" />
        })</Tag>
      ),
      '': <Tag color="orange">{_get(amount, 'discounted')} THB ({
        <FormattedMessage id="paymentStatus.pending" defaultMessag="Pending Payment" />
      })</Tag>
    })[status || '']
    const { discounted, discount, total } = amount
    return (
      <div>
        <Form
          onSubmit={this.handleSubmitRegistration}
          style={{ padding: '26px' }}
          className="EventRegisterPage"
        >
          <div
            className="eventDetails"
            style={{
              paddingTop: '85px',
              display: 'flex',
              justifyContent: ' center'
            }}
          >
            <div className="eventTitle">
              {_get(data, ['registration', 'event', 'name', locale])}
            </div>
          </div>
          <div style={{ maxWidth: '1000px', margin: 'auto' }}>
            <RegistrationSteps step="complete" />
            <div
              style={{
                padding: '26px',
                background: 'white',
                borderRadius: '0 0 8px 8px'
              }}
            >
              <div className="simpleBgColors" tyle={{
                fontSize: 'large',
                textAlign: 'center',
                marginBottom: '1em'
              }}>
                <Link to={`/events/${slug}`} className="modlink2">
                  {event.name[locale]}
                </Link> - {registrationType.name[locale]}
              </div>
              <Row>
                <Col xs={4}>
                  <span>
                    {code &&
                    <span style={{ fontSize: 'large' }}>{{
                      en: 'Reg. No.',
                      th: 'ใบสมัคร'
                    }[locale]}: {code}</span>
                    }
                  </span>
                </Col>
                <Col xs={20}>
                  <div>
                    Race Day : {moment(event.startDate).format('Do MMMM YYYY')}
                    {' '}
                    {$paymentStatus}
                    {' '}
                    {status !== 'paid' && expireAt &&
                      (expired
                        ? <Tag color="red">
                          <FormattedMessage id="app.expired" defaultMessage="Expired" />
                        </Tag>
                        : <Tag color="orange">
                          <FormattedMessage id="app.payBeforeDate" defaultMessage="Please pay before {date}" values={{
                            date: moment(expireAt).format('Do MMMM HH:mm')
                          }}/>
                        </Tag>
                      )
                    }
                  </div>
                </Col>
                <Col xs={24}>
                  <div>
                    {participants.map(participant => {
                      const taxInvoiceTypeId = _get(participant, 'profile.taxInvoice.type')
                      const taxInvoiceType = taxInvoiceOptions.find(o => o._id === taxInvoiceTypeId)
                      const emergencyContact = _get(participant, 'profile.emergencyContact')
                      return <Row
                        style={{ borderBottom: '1px dashed gainsboro' }}
                        key={participant._id}
                      >
                        <Col xs={23} sm={11}>
                          <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {
                                {
                                  en: 'Name - Surname',
                                  th: 'ชื่อ - นามสกุล'
                                }[locale]
                              }
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.firstName}{' '}
                              {participant.profile.lastName}
                            </span>
                          </div>
                          <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Gender', th: 'เพศ' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.gender}
                            </span>
                          </div>
                          <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'BirthDay', th: 'วันเกิด' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {moment(participant.profile.birthDate).format(
                                'D MMMM YYYY'
                              )}
                            </span>
                          </div>
                          <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Email', th: 'อีเมล' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.email}
                            </span>
                          </div>
                          <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Telephone', th: 'โทรศัพท์' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.telephone}
                            </span>
                          </div>
                          {participant.profile.nationality && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Nationality', th: 'สัญชาติ' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.nationality}
                            </span>
                          </div>}
                          {participant.profile.nationalId && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'National ID / Passport ID', th: 'เลขประจำตัวประชาชน' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.nationalId}
                            </span>
                          </div>}
                          {participant.profile.street && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Address', th: 'ที่อยู่' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.street}
                            </span>
                          </div>}
                          {participant.profile.locality && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Locality', th: 'ตำบล/แขวง' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.locality}
                            </span>
                          </div>}
                          {participant.profile.city && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'City', th: 'อำเภอ/เขต' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.city}
                            </span>
                          </div>}
                          {participant.profile.province && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Province of Residence', th: 'จังหวัดที่พักอาศัย' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.province}
                            </span>
                          </div>}
                          {participant.profile.country && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Country of Residence', th: 'ประเทศที่พักอาศัย' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.country}
                            </span>
                          </div>}
                          {taxInvoiceType &&
                            <div>
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Tax Invoice', th: 'ใบกำกับภาษี' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {taxInvoiceType[locale]}
                                </span>
                              </div>
                              {taxInvoiceTypeId !== 'none' && [
                                <div className="eventBottomDetailBox" key="taxId">
                                  <span className="eventBottomDetailTitle">
                                    {{ en: 'Tax ID', th: 'หมายเลขประจำตัวผูเสียภาษี' }[locale]}
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {_get(participant, 'profile.taxInvoice.taxId')}
                                  </span>
                                </div>,
                                <div className="eventBottomDetailBox" key="address">
                                  <span className="eventBottomDetailTitle">
                                    {{ en: 'Address', th: 'ที่อยู่' }[locale]}
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {_get(participant, 'profile.taxInvoice.address')}
                                  </span>
                                </div>]}
                            </div>
                          }
                          {emergencyContact &&
                            <div>
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Emergency Contact', th: 'ผู้ติดต่อกรณีฉุกเฉิน' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {emergencyContact.name}
                                </span>
                              </div>
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Emergency Contact Relationship', th: 'ควาสัมพันธ์ผู้ติดต่อ' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {emergencyContact.relationship}
                                </span>
                              </div>
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Emergency Contact Phone Number', th: 'โทรศัพท์ผู้ติดต่อกรณีฉุกเฉิน' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {emergencyContact.phone}
                                </span>
                              </div>
                            </div>
                          }
                        </Col>
                        <Col xs={23} sm={11}>
                          {participant.tickets.map(ticket =>
                            <div key={ticket._id} >
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {
                                    { en: 'Race', th: 'ประเภทการแข่งขัน' }[
                                      locale
                                    ]
                                  }
                                </span>
                                <span className="eventBottomDetailData">
                                  {ticket.ticketType.name[locale]}
                                </span>
                              </div>
                              {_get(ticket, 'ticketType.race.ageCategories') && <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Category', th: 'รุ่นอายุ' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {this.ageCategoryString(
                                    getAgeCategory({
                                      race: ticket.ticketType.race,
                                      birthDate:
                                        participant.profile.birthDate,
                                      gender: participant.profile.gender
                                    })
                                  )}
                                </span>
                              </div>}
                              {!hideNumber && ticket.number && (
                                <div className="eventBottomDetailBox" >
                                  <span className="eventBottomDetailTitle">
                                    {
                                      { en: 'BIB Number', th: 'เลขบิบ' }[
                                        locale
                                      ]
                                    }
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {bibNumber(ticket.number)}
                                  </span>
                                </div>
                              )}
                              {ticket.reservedNumber && (
                                <div>
                                  <span className="eventBottomDetailTitle">
                                    {
                                      { en: 'BIB Number (VIP)', th: 'เลขบิบ (VIP)' }[
                                        locale
                                      ]
                                    }
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {bibNumber(ticket.reservedNumber)}
                                  </span>
                                </div>
                              )}
                              {ticket.nameOnBib &&
                                  <div>
                                    <span className="eventBottomDetailTitle">
                                      {
                                        {
                                          en: 'Name On Bib',
                                          th: 'ชื่อบนเบอร์วิ่ง'
                                        }[
                                          locale
                                        ]
                                      }
                                    </span>
                                    <span className="eventBottomDetailData">
                                      {ticket.nameOnBib}
                                    </span>
                                  </div>
                              }
                              {_sortBy(ticket.options, ['question.order']).map(option => {
                                // console.log({ option })
                                const optionValue = {
                                  Open: option.value,
                                  Choice: option.itemId,
                                  MultiChoice: option.itemIds.join(', ')
                                }[option.question.kind]

                                return (
                                  <div
                                    key={option._id}
                                    className="eventBottomDetailBox"
                                  >
                                    <span className="eventBottomDetailTitle">
                                      {option.question.name[locale]}
                                    </span>
                                    <span className="eventBottomDetailData">
                                      {optionValue}
                                    </span>
                                  </div>
                                )
                              })}
                              {event.shirts.length > 0 && ticket.shirtId &&
                                <div
                                  key="shirt"
                                  className="eventBottomDetailBox"
                                >
                                  <span className="eventBottomDetailTitle">
                                    {{ en: 'Shirt', th: 'เสื้อ' }[locale]}
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {event.shirtTypes.find(st => st._id === ticket.shirtTypeId).name[locale]}&nbsp;
                                    {event.shirts.find(s => s._id === ticket.shirtId).name[locale]}
                                  </span>
                                </div>
                              }
                            </div>
                          )}
                        </Col>
                      </Row>
                    })}
                  </div>
                </Col>
              </Row>
              <div>{eventProducts.map(eventProduct => {
                const productType = _get(eventProduct, 'eventProductType')
                return <div key={eventProduct._id}>
                  {_get(productType, ['name', locale])} (<FormattedMessage id="app.amountBaht" values={{ amount: productType.price }} />)
                  <div>
                    {eventProduct.options.map(option => (
                      <div key={option._id}><span className="eventBottomDetailTitle">{_get(option, ['question', 'name', locale])}</span> <span className="eventBottomDetailData">{option.value || option.itemId || option.itemIds}</span></div>
                    ))}
                  </div>
                </div>
              })}
              </div>
              {couponCodes && couponCodes.length > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                Code: {couponCodes.map(cc => cc.code).join(', ')}
              </div>}
              {discount > 0 && <div style={{ padding: '8px', textAlign: 'right', textDecoration: 'line-through' }}>
                Total: {total} THB
              </div>}
              {systemFee > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
              Fee: +{systemFee} THB
              </div>}
              <div style={{ padding: '8px', textAlign: 'right' }}>
                Total: {discounted} THB
              </div>
              <div style={{ padding: '8px', textAlign: 'right' }}>
                <Link to={`/dashboard`}>
                  <Button type="primary" style={{ marginRight: '8px' }}>
                    <FormattedMessage id="app.myRegistrations" defaultMessag="My Registrations" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

export default compose(
  graphql(registrationQuery, {
    options: ({ match: { params: { id } } }) => ({
      variables: { _id: id },
      fetchPolicy: 'network-only'
    })
  }),
  inject('i18n'),
  observer
)(RegistrationView)



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/Registration/Registration.js